import externalScript from './external-script'

const apiKey = process.env.GOOGLE_API_KEY
const clientId = process.env.GOOGLE_CLIENT_ID

const scriptURL = 'https://apis.google.com/js/api.js'
const discoveryDocs = ['https://www.googleapis.com/discovery/v1/apis/drive/v3/rest']
const scope = 'https://www.googleapis.com/auth/drive.metadata.readonly'
const fields = 'name,mimeType,size'

let initialized = false
let authenticated = false

const errors = {
  init: 'Unable to initialize',
  auth: 'Unable to authenticate',
  file: 'Unable to retrieve file',
  url: 'Invalid URL'
}

export default {
  isSupportedURL: function (url) {
    const valid = !!url.match(/^https:\/\/(drive|docs)\.google\.com/)
    if (!valid) {
      return
    }

    return !!this.getFileID(url)
  },
  getFileID: function (url) {
    const match = url.match(/[-\w]{25,}/)
    return match ? match[0] : null
  },
  init: function () {
    return new Promise((resolve, reject) => {
      if (initialized) {
        return resolve()
      }

      externalScript.load(scriptURL).then(() => {
        window.gapi.load('client', () => {
          window.gapi.client.init({ apiKey, clientId, scope, discoveryDocs }).then(() => {
            initialized = true
            resolve()
          }, () => {
            reject(errors.init)
          })
        })
      }, () => {
        reject(errors.init)
      })
    })
  },
  authenticate: function () {
    return new Promise((resolve, reject) => {
      if (authenticated) {
        return resolve()
      }

      window.gapi.auth2.getAuthInstance().isSignedIn.listen((signedIn) => {
        authenticated = signedIn
      })

      authenticated = window.gapi.auth2.getAuthInstance().isSignedIn.get()

      window.gapi.auth2.getAuthInstance().signIn().then(() => {
        resolve()
      }, () => {
        reject(errors.auth)
      })
    })
  },
  get: function (url) {
    return new Promise((resolve, reject) => {
      if (!this.isSupportedURL(url)) {
        reject(errors.url)
      }

      const fileId = this.getFileID(url)
      this.init().then(() => {
        this.authenticate().then(() => {
          window.gapi.client.drive.files.get({ fileId, fields }).then((response) => {
            resolve(response.result)
          }, () => {
            reject(errors.file)
          })
        }, () => {
          reject(errors.auth)
        })
      }, () => {
        reject(errors.init)
      })
    })
  }
}
